import { render, staticRenderFns } from "./medicaldevices-wearables.vue?vue&type=template&id=5f787414&scoped=true&"
import script from "./medicaldevices-wearables.vue?vue&type=script&lang=js&"
export * from "./medicaldevices-wearables.vue?vue&type=script&lang=js&"
import style0 from "./medicaldevices-wearables.vue?vue&type=style&index=0&id=5f787414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f787414",
  null
  
)

component.options.__file = "medicaldevices-wearables.vue"
export default component.exports